import { render, staticRenderFns } from "./VideoTable.vue?vue&type=template&id=ece7858c&scoped=true&"
import script from "./VideoTable.vue?vue&type=script&lang=js&"
export * from "./VideoTable.vue?vue&type=script&lang=js&"
import style0 from "./VideoTable.vue?vue&type=style&index=0&id=ece7858c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece7858c",
  null
  
)

export default component.exports